import { http, delay, HttpResponse } from 'msw';
import { API_BASE_URL } from 'src/api/api-base';
import { endpoints } from 'src/config/endpoints';
import Instrument from 'src/models/instrument';
import { Instruments } from 'src/fixtures/instruments';

export default [
  http.get(API_BASE_URL + endpoints.instruments.getAll, async () => {
    await delay('real');
    return HttpResponse.json({ Data: Instruments} );
  }),
  http.post(API_BASE_URL + endpoints.instruments.create, async (req) => {
    await delay('real');

    const instrument = (await req.request.json()) as Instrument;
    Instruments.push(instrument);

    return HttpResponse.json({ Data: instrument });
  }),
  http.put(API_BASE_URL + endpoints.instruments.update(':instrumentId'), async (req) => {
    await delay('real');

    const instrument = (await req.request.json()) as Instrument;
    const index = Instruments.findIndex((i) => i.id === Number(instrument.id));
    Instruments[index] = instrument;

    return HttpResponse.json({ Data: instrument });
  }),
  http.delete(API_BASE_URL + endpoints.tags.delete(':instrumentId'), async (req) => {
    await delay('real');

    const { instrumentId } = req.params;
    const index = Instruments.findIndex((instrument) => instrument.id === Number(instrumentId));
    Instruments.splice(index, 1);

    return HttpResponse.json({});
  }),
];
